export default {"src":"/_next/static/media/filter.ada4076d.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};